import Tool, { type IToolAvailableInput } from './Tool';
import {
  hasFrameMemberBehaviors,
  hasLayout,
  isMindMapObject,
} from '../objects/guards';

class ToolLayoutAutomatic extends Tool {
  static toolName = 'Layout automatically';

  static action({ selection }) {
    selection.setOnObjects('layoutManual', false);
  }

  static available({ selection }: IToolAvailableInput): boolean {
    const obj = selection?.firstObject();
    if (!obj) return false;

    if (!obj.container || !obj.layoutPosition) return false;

    return obj.layoutManual;
  }
}

class ToolLayoutManual extends Tool {
  static toolName = 'Layout manually';

  static action({ selection }) {
    selection.setOnObjects('layoutManual', true);
  }

  static available({ selection }: IToolAvailableInput): boolean {
    const obj = selection?.firstObject();
    if (!obj) return false;

    if (
      obj.layoutManual ||
      !obj.container ||
      !obj.layoutPosition ||
      !hasFrameMemberBehaviors(obj) ||
      isMindMapObject(obj)
    ) {
      return false;
    }

    const frame = obj.inFrame();
    return frame !== undefined && hasLayout(frame);
  }
}

export { ToolLayoutManual, ToolLayoutAutomatic };
